
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from '@/contexts/AuthContext';
import { UserWithProfile } from '@/types/auth';

export const useUser = () => {
  const { session, user } = useAuth();

  const { data: profile, isLoading, error } = useQuery({
    queryKey: ['user-profile', user?.id],
    queryFn: async () => {
      if (!user?.id) return null;
      
      console.log('Fetching profile for user:', user.id);
      
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single();
        
      if (error) {
        console.log('Profile fetch error:', error);
        // If profile doesn't exist, return null instead of throwing
        if (error.code === 'PGRST116') {
          return null;
        }
        throw error;
      }
      
      console.log('Profile fetched successfully:', data);
      return data;
    },
    enabled: !!user?.id,
    retry: 1, // Only retry once for profile fetching
  });

  // Create user with profile, with enhanced fallbacks
  const userWithProfile: UserWithProfile | null = user ? {
    ...user,
    first_name: profile?.first_name || user?.user_metadata?.first_name || null,
    last_name: profile?.last_name || user?.user_metadata?.last_name || null,
    job_title: profile?.job_title || null,
    company: profile?.company || null,
    experience_level: profile?.experience_level || null,
    goals: profile?.goals || null
  } : null;

  return {
    user: userWithProfile,
    isLoading: isLoading,
    error,
  };
};
